// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsViewOrbit_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8 8C9.65685 8 11 6.65685 11 5 11 3.34315 9.65685 2 8 2 6.34315 2 5 3.34315 5 5 5 6.65685 6.34315 8 8 8ZM13.5 9.00009C13.5 8.31606 12.6616 7.71224 11.2361 7.3516 11.6192 6.8253 11.8771 6.20196 11.9658 5.52539 14.3759 6.21454 16 7.51248 16 9.00009 16 10.1673 15.0001 11.2178 13.4052 11.949L11.0664 10.6897C12.5948 10.335 13.5 9.71084 13.5 9.00009Z" class="svg-bg"/>
  <path d="M4.03418 5.52539C4.12293 6.20196 4.38076 6.8253 4.76385 7.3516C3.33844 7.71224 2.5 8.31606 2.5 9.00009C2.5 9.98932 4.25353 10.8108 7 10.9716V10.0001L11 12L7 14V12.9691C3.05369 12.7231 0 11.0399 0 9.00009C0 7.51248 1.62414 6.21454 4.03418 5.52539Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsViewOrbit is a generated icon component.
 */
let IconRmsViewOrbit = IconRmsViewOrbit_1 = class IconRmsViewOrbit extends IconBaseElement {
    render() {
        return html `${IconRmsViewOrbit_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsViewOrbit.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconRmsViewOrbit = IconRmsViewOrbit_1 = __decorate([
    customElement('zui-icon-rms-view-orbit')
], IconRmsViewOrbit);
export { IconRmsViewOrbit };
